const Configuration = () => {
    return ( Configuration );
}
 
export default Configuration;